import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaBed } from "react-icons/fa"; // Icon for rooms
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from "../../constants";

function AvailableRoomCard() {
  const [totalAvailableRooms, setTotalAvailableRooms] = useState(0);
  const [totalFreePlaces, setTotalFreePlaces] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAvailableRooms = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/accommodation/available`);
        const { shelters } = response.data;
  
        let totalAvailableRooms = 0;
        let totalFreePlaces = 0;
  
        shelters.forEach((shelter) => {
          shelter.availableRooms.forEach((room) => {
            if (room.freePlaces > 0) {
              totalAvailableRooms += 1; 
              totalFreePlaces += room.freePlaces; 
            }
          });
        });
  
        setTotalAvailableRooms(totalAvailableRooms);
        setTotalFreePlaces(totalFreePlaces);
      } catch (error) {
        console.error("Error fetching available rooms data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchAvailableRooms();
  }, []);
  

  return (
<div
  style={{
    background:
      totalAvailableRooms === 0
        ? "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)"
        : "linear-gradient(135deg, #198754 0%, #20c997 100%)",
    borderRadius: "12px",
    color: "white",
    padding: "20px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  }}
  className="hover-scale w-100"
>
  <div className="card-body p-2">
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <FaBed
        size={30}
        style={{
          stroke: "white",
          strokeWidth: "10px",
          filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
        }}
      />

      <div className="text-end">
        <h6
          className="fw-bold mb-1 text-white text-truncate"
          style={{ fontSize: "1.2rem", minWidth: "120px" }}
        >
          {loading ? "..." : `${totalAvailableRooms} Rooms`}
        </h6>
        <h6
          className="fw-bold mb-0 text-white text-truncate"
          style={{ fontSize: "1rem", minWidth: "120px" }}
        >
          {loading ? "..." : `${totalFreePlaces} Free Places`}
        </h6>
      </div>
    </div>

    <small
      className="text-white-40 d-block mt-2"
      style={{ fontSize: "0.85rem" }}
    >
      {loading
        ? "..."
        : "Total available rooms and free places across all shelters."}
    </small>
  </div>
</div>



  );
}

export default AvailableRoomCard;